import { Fragment, type ReactElement } from "react";
import { useLocation, useParams } from "react-router";

import type { MoveState } from "../../components/notice.js";
import { NotFoundPage } from "../account/message-pages.js";

/** 画面に渡す URL の値。 */
export interface TenantScope {
    /** 契約（URL の <c>{契約}</c>）。 */
    readonly tenantId: number;
    /** 対象の利用者（URL の最後。メールアドレス）。無い画面では undefined。 */
    readonly id: string | undefined;
}

const noticeOf = (state: unknown): string | undefined =>
    typeof state === "object" && state !== null ? (state as MoveState).notice : undefined;

/**
 * <c>/tenant/Edit/{契約}/TenantUser/…</c> の値を読んで画面へ渡す。
 *
 * <b>契約が数でなければ「見つからない」</b>（サーバのルートも数しか受けない）。
 * <b>移った先で知らせる文があれば画面を作り直す</b>——招待の後は同じ URL の一覧へ戻り、
 * URL が変わらないと一覧を読み直さない。
 */
export function TenantScoped({ render }: {
    readonly render: (scope: TenantScope) => ReactElement;
}): ReactElement {
    const { tenantId, id } = useParams();
    const location = useLocation();

    if (tenantId === undefined || !/^\d+$/u.test(tenantId)) {
        return <NotFoundPage />;
    }

    const notice = noticeOf(location.state);
    return (
        <Fragment key={notice === undefined ? "page" : location.key}>
            {render({ tenantId: Number(tenantId), id })}
        </Fragment>
    );
}
